var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('gl-sprintf',{attrs:{"message":_vm.$options.i18n[_vm.getTipNum]},scopedSlots:_vm._u([{key:"link",fn:function({ content }){return [_c('kbd',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(content),expression:"content"}],staticClass:"vertical-align-normalization gl-py-2 gl-text-base"},[_vm._v(_vm._s(content))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }